import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import {
  ArchivDocumentPolizzeCreate,
  DateString,
  FileBucketMetadata,
  GrueneKarteDruck,
  KeyValue,
  ObjektEinsicht,
  PayloadArchivDocumentGutachtenList,
  PayloadArchivDocumentList,
  PayloadArchivDocumentPolizzeCreateList,
  PayloadBeteiligung,
  PayloadBoolean,
  PayloadEsignLogList,
  PayloadEsignResultList,
  PayloadFahrzeugResultList,
  PayloadFileBucketMetadata,
  PayloadFileBucketMetadataList,
  PayloadFremdeFuehrung,
  PayloadGebaeudeResultList,
  PayloadInteger,
  PayloadKlauselList,
  PayloadLVKPolizzeLeben,
  PayloadMahnhistorieResultList,
  PayloadNebenversicherungList,
  PayloadObjektEinsichtStatus,
  PayloadPersonReferatList,
  PayloadPoldruckOptions,
  PayloadPolizze,
  PayloadPolizzeAenderungen,
  PayloadPolizzeApolList,
  PayloadPolizzeBuchungDetail,
  PayloadPolizzeBuchungResultList,
  PayloadPolizzeCocheckList,
  PayloadPolizzeDFZList,
  PayloadPolizzeFampassXMLDatenList,
  PayloadPolizzeFond,
  PayloadPolizzeFreischadenList,
  PayloadPolizzeGenehmigungList,
  PayloadPolizzeIdentitaetsdatenList,
  PayloadPolizzeMailingFehlerList,
  PayloadPolizzeMailingList,
  PayloadPolizzeObjekt,
  PayloadPolizzeOposten,
  PayloadPolizzeOpostenSummen,
  PayloadPolizzePersonResultList,
  PayloadPolizzeProduktionsblatt,
  PayloadPolizzeProvisionList,
  PayloadPolizzeProvisionResultList,
  PayloadPolizzeRabattkontoResult,
  PayloadPolizzeResult,
  PayloadPolizzeResultList,
  PayloadPolizzeSchaden,
  PayloadPolizzeZahlung,
  PayloadPolizzeZisList,
  PayloadPolizzeZusaetzlicheTexte,
  PayloadPolizzeZusatzangabeList,
  PayloadPosition,
  PayloadPositionGewinnkontoList,
  PayloadPositionGewinnprognoseList,
  PayloadPositionLebenBilanz,
  PayloadPositionLebenFond,
  PayloadPositionLebenFondAnteileList,
  PayloadPositionLebenkontoList,
  PayloadPositionPrognoseList,
  PayloadPositionRentenkontoList,
  PayloadPositionResultList,
  PayloadPositionSelbstbehaltList,
  PayloadPositionTeilentnahmenList,
  PayloadPositionVeranlagungList,
  PayloadPositionZuzahlungList,
  PayloadQuestionsData,
  PayloadRabattkontobuchungList,
  PayloadRKWAuskunftResult,
  PayloadRueckversicherung,
  PayloadString,
  PayloadTerminList, PayloadTodoResult,
  PayloadTodoResultList,
  PayloadVertrag,
  PayloadVertragAnpassung,
  PayloadVertragResultList,
  PayloadVertragSelbstbehaltList,
  PayloadVinkulierungList, PayloadZinsspektrum,
  PayloadZusaetzlicheTexte,
  PoldruckSendData,
  QuestionsData, TodoCreation
} from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestPoliceService extends RestService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  searchPolice(searchParams: KeyValue<string, any>[]): Observable<PayloadPolizzeResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPolizzeResultList>(
        this.baseUrl + '/polizze/suche',
        options);
  }

  public getPoliceForId(policeID: number): Observable<PayloadPolizze> {
    return this.http
      .get<PayloadPolizze>(this.baseUrl + '/polizze/' + policeID, this.httpOptions);
  }

  public getVertragForPolice(polint: number, vernr: number): Observable<PayloadVertrag> {
    return this.http
      .get<PayloadVertrag>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr, this.httpOptions);
  }

  public getVertraegeForPolice(polint: number): Observable<PayloadVertragResultList> {
    return this.http
      .get<PayloadVertragResultList>(this.baseUrl + '/polizze/' + polint + '/vertrag', this.httpOptions);
  }

  public getPositionForVertraege(polint: number, vernr: number, posnr: number): Observable<PayloadPosition> {
    return this.http
      .get<PayloadPosition>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr, this.httpOptions);
  }

  public getPositionenForVertraege(polint: number, vernr: number): Observable<PayloadPositionResultList> {
    return this.http
      .get<PayloadPositionResultList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position', this.httpOptions);
  }

  public getPersonenForPolice(polint: number): Observable<PayloadPolizzePersonResultList> {
    return this.http
      .get<PayloadPolizzePersonResultList>(this.baseUrl + '/polizze/' + polint + '/personen', this.httpOptions);
  }

  public getObjFahrzeugForPolice(polint: number): Observable<PayloadFahrzeugResultList> {
    return this.http
      .get<PayloadFahrzeugResultList>(this.baseUrl + '/polizze/' + polint + '/objekte/fahrzeuge', this.httpOptions);
  }

  public getObjGebaeudeForPolice(polint: number): Observable<PayloadGebaeudeResultList> {
    return this.http
      .get<PayloadGebaeudeResultList>(this.baseUrl + '/polizze/' + polint + '/objekte/gebaeude', this.httpOptions);
  }

  public getObjekte(polint: number): Observable<PayloadPolizzeObjekt> {
    return this.http
      .get<PayloadPolizzeObjekt>(this.baseUrl + '/polizze/' + polint + '/objekte', this.httpOptions);
  }

  public getBuchungenForPolice(polint: number): Observable<PayloadPolizzeBuchungResultList> {
    return this.http
      .get<PayloadPolizzeBuchungResultList>(this.baseUrl + '/polizze/' + polint + '/buchungen', this.httpOptions);
  }

  public getBuchungDetailPolice(polint: number, buchungId: number): Observable<PayloadPolizzeBuchungDetail> {
    return this.http
      .get<PayloadPolizzeBuchungDetail>(this.baseUrl + '/polizze/' + polint + '/buchungen/detail/' + buchungId, this.httpOptions);
  }

  public getOpostenForPolice(polint: number): Observable<PayloadPolizzeOpostenSummen> {
    return this.http
      .get<PayloadPolizzeOpostenSummen>(this.baseUrl + '/polizze/' + polint + '/buchungen/oposten', this.httpOptions);
  }

  public getOpostenDetailForPolice(polint: number, opostenId: number): Observable<PayloadPolizzeOposten> {
    return this.http
      .get<PayloadPolizzeOposten>(this.baseUrl + '/polizze/' + polint + '/buchungen/oposten/' + opostenId, this.httpOptions);
  }

  public getBuchungenOpostenZahlungDetail(polint: number, zahlungId: number): Observable<PayloadPolizzeZahlung> {
    return this.http
      .get<PayloadPolizzeZahlung>(this.baseUrl + '/polizze/' + polint + '/buchungen/oposten/zahlung/' + zahlungId, this.httpOptions);
  }

  public getProvisionForPolice(polint: number): Observable<PayloadPolizzeProvisionList> {
    return this.http
      .get<PayloadPolizzeProvisionList>(this.baseUrl + '/polizze/' + polint + '/provision', this.httpOptions);
  }

  public getGebuchteProvisionForPolice(polint: number): Observable<PayloadPolizzeProvisionResultList> {
    return this.http
      .get<PayloadPolizzeProvisionResultList>(this.baseUrl + '/polizze/' + polint + '/provision/buchung', this.httpOptions);
  }

  public getKlauselnForPolice(polint: number): Observable<PayloadKlauselList> {
    return this.http
      .get<PayloadKlauselList>(this.baseUrl + '/polizze/' + polint + '/klausel', this.httpOptions);
  }

  public getKlauselnForVertrag(polint: number, vernr: number): Observable<PayloadKlauselList> {
    return this.http
      .get<PayloadKlauselList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/klausel', this.httpOptions);
  }

  public getPositionKlauselnMerkmaleForVertrag(polint: number, vernr: number): Observable<PayloadKlauselList> {
    return this.http
      .get<PayloadKlauselList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/klausel/position/merkmal', this.httpOptions);
  }

  public getAvbForVertrag(polint: number, vernr: number): Observable<PayloadKlauselList> {
    return this.http
      .get<PayloadKlauselList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/avb', this.httpOptions);
  }

  public getKlauselnForPosition(polint: number, vernr: number, posnr: number): Observable<PayloadKlauselList> {
    return this.http
      .get<PayloadKlauselList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr + '/klausel', this.httpOptions);
  }

  public getMalingsForPolice(polint: number): Observable<PayloadPolizzeMailingList> {
    return this.http
      .get<PayloadPolizzeMailingList>(this.baseUrl + '/polizze/' + polint + '/mailings', this.httpOptions);
  }

  public getKorrespondenz(polint: number, all?: boolean): Observable<PayloadPolizzeMailingList> {
    const params = {all};
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPolizzeMailingList>(this.baseUrl + '/polizze/' + polint + '/korrespondenz', all ? options : this.httpOptions);
  }

  public getKorrespondenzDetail(polint: number, versandId: number): Observable<PayloadPolizzeMailingFehlerList> {
    return this.http
      .get<PayloadPolizzeMailingFehlerList>(this.baseUrl + '/polizze/' + polint + '/korrespondenz/' + versandId, this.httpOptions);
  }

  public getDocuments(polint: number): Observable<PayloadArchivDocumentList> {
    return this.http
      .get<PayloadArchivDocumentList>(this.baseUrl + '/polizze/' + polint + '/document', this.httpOptions);
  }

  public getGutachten(polint: number): Observable<PayloadArchivDocumentGutachtenList> {
    return this.http
      .get<PayloadArchivDocumentGutachtenList>(this.baseUrl + '/polizze/' + polint + '/document/gutachten', this.httpOptions);
  }

  public getAenderungen(polint: number): Observable<PayloadPolizzeAenderungen> {
    return this.http
      .get<PayloadPolizzeAenderungen>(this.baseUrl + '/polizze/' + polint + '/aenderungen', this.httpOptions);
  }

  public getTermine(polint: number): Observable<PayloadTerminList> {
    return this.http
      .get<PayloadTerminList>(this.baseUrl + '/polizze/' + polint + '/termine', this.httpOptions);
  }

  public getRendement(polint: number): Observable<PayloadTerminList> {
    return this.http
      .get<PayloadTerminList>(this.baseUrl + '/polizze/' + polint + '/termine/rendement', this.httpOptions);
  }

  public getFFVerband(polint: number): Observable<PayloadFremdeFuehrung> {
    return this.http
      .get<PayloadFremdeFuehrung>(this.baseUrl + '/polizze/' + polint + '/fremdefuehrung/verband', this.httpOptions);
  }

  public getFFWork(polint: number): Observable<PayloadFremdeFuehrung> {
    return this.http
      .get<PayloadFremdeFuehrung>(this.baseUrl + '/polizze/' + polint + '/fremdefuehrung/work', this.httpOptions);
  }

  public getVertragAnpassung(polint: number, vertragId: number): Observable<PayloadVertragAnpassung> {
    return this.http
      .get<PayloadVertragAnpassung>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/anpassung', this.httpOptions);
  }

  public getVertragNebenversicherungen(polint: number, vertragId: number): Observable<PayloadNebenversicherungList> {
    return this.http
      .get<PayloadNebenversicherungList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/nebenversicherung', this.httpOptions);
  }

  public getVertragRueckversicherung(polint: number, vertragId: number): Observable<PayloadRueckversicherung> {
    return this.http
      .get<PayloadRueckversicherung>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/rueckversicherung', this.httpOptions);
  }

  public getVertragVinkulierung(polint: number, vertragId: number): Observable<PayloadVinkulierungList> {
    return this.http
      .get<PayloadVinkulierungList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/vinkulierung', this.httpOptions);
  }

  public getSchaeden(polint: number): Observable<PayloadPolizzeSchaden> {
    return this.http
      .get<PayloadPolizzeSchaden>(this.baseUrl + '/polizze/' + polint + '/schaden', this.httpOptions);
  }

  public getZusaetzlicheVertragsTexte(polint: number, vertragId: number, raw: boolean): Observable<PayloadZusaetzlicheTexte> {
    const params = {raw};
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadZusaetzlicheTexte>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/texte', options);
  }

  public getZusaetzlichePositionsTexte(polint: number, vertragId: number, positionId: number, raw: boolean): Observable<PayloadZusaetzlicheTexte> {
    const params = {raw};
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadZusaetzlicheTexte>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/position/' + positionId + '/texte', options);
  }

  public getPolizzeZusaetzlicheTexte(polint: number, raw: boolean): Observable<PayloadPolizzeZusaetzlicheTexte> {
    const params = {raw};
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPolizzeZusaetzlicheTexte>(this.baseUrl + '/polizze/' + polint + '/texte', options);
  }

  public getInkassoTermineForPolice(polint: number): Observable<PayloadTerminList> {
    return this.http
      .get<PayloadTerminList>(this.baseUrl + '/polizze/' + polint + '/termine/inkasso', this.httpOptions);
  }

  public getZusatzangaben(polint: number): Observable<PayloadPolizzeZusatzangabeList> {
    return this.http
      .get<PayloadPolizzeZusatzangabeList>(this.baseUrl + '/polizze/' + polint + '/zusatzangaben', this.httpOptions);
  }

  public getVertragObjekte(polint: number, vertragId: number): Observable<PayloadPolizzeObjekt> {
    return this.http
      .get<PayloadPolizzeObjekt>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/objekte', this.httpOptions);
  }

  public getVertragPersonen(polint: number, vertragId: number): Observable<PayloadPolizzePersonResultList> {
    return this.http
      .get<PayloadPolizzePersonResultList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/personen', this.httpOptions);
  }

  public getPositionObjekte(polint: number, vertragId: number, posnr: number): Observable<PayloadPolizzeObjekt> {
    return this.http
      .get<PayloadPolizzeObjekt>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/position/' + posnr + '/objekte', this.httpOptions);
  }

  public getPositionPersonen(polint: number, vertragId: number, posnr: number): Observable<PayloadPolizzePersonResultList> {
    return this.http
      .get<PayloadPolizzePersonResultList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/position/' + posnr + '/personen', this.httpOptions);
  }

  public getPolDruckOptions(polint: number): Observable<PayloadPoldruckOptions> {
    return this.http
      .get<PayloadPoldruckOptions>(this.baseUrl + '/polizze/' + polint + '/druck/options', this.httpOptions);
  }

  public printDuplikatsPolizze(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/duplikat', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public sendOfferte(polint: number, body: PoldruckSendData, bccMe?: boolean): Observable<PayloadBoolean> {
    const params = {bccMe: bccMe};
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .post<PayloadBoolean>(this.baseUrl + '/polizze/' + polint + '/druck/offert/send', body, options);
  }

  public getOffertAlleDocList(polint: number, ohneVertragsPraemie?: boolean, mitBedingungen?: boolean): Observable<PayloadFileBucketMetadataList> {
    const params = {
      ohneVertragsPraemie: ohneVertragsPraemie,
      mitBedingungen:      mitBedingungen
    };
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadFileBucketMetadataList>(this.baseUrl + '/polizze/' + polint + '/druck/offertalle', options);
  }

  public downloadOffertAlleDoc(polint: number, file: FileBucketMetadata): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/offertalle/download', file, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getOffertWithBeilagenDocList(polint: number, ohneVertragsPraemie?: boolean, mitBedingungen?: boolean): Observable<PayloadFileBucketMetadataList> {
    const params = {
      ohneVertragsPraemie: ohneVertragsPraemie,
      mitBedingungen:      mitBedingungen
    };
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadFileBucketMetadataList>(this.baseUrl + '/polizze/' + polint + '/druck/offertwithbeilagen', options);
  }

  public printGebaeudebewertung(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/gebaeudebewertung', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPolizzenAuskunft(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/auskunft', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printBeratungsprotokoll(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/beratungsprotokoll', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printAntrag(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/antrag', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPoldruck(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/poldruck', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPoldruckVertrag(polint: number, vertragId: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(`${this.baseUrl}/polizze/${polint}/druck/poldruckvertrag/${vertragId}`, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPoldruckPosition(polint: number, vertragId: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(`${this.baseUrl}/polizze/${polint}/druck/poldruckposition/${vertragId}`, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPoldruckAllPositionen(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(`${this.baseUrl}/polizze/${polint}/druck/poldruckposition`, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPoldruckAllPositionenWord(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(`${this.baseUrl}/polizze/${polint}/druck/poldruckpositionword`, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPoldruckPositionWord(polint: number, vertragId: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(`${this.baseUrl}/polizze/${polint}/druck/poldruckpositionword/${vertragId}`, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPoldruckWord(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/poldruckword', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printAntragWord(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/antragword', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printOffertWord(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/offertword', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printStatusdruck(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/status', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printVersbest(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/versbest', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printOffert(polint: number, ohneVertragsPraemie?: boolean, mitBedingungen?: boolean): Observable<HttpResponse<Blob>> {
    const params = {
      ohneVertragsPraemie: ohneVertragsPraemie,
      mitBedingungen:      mitBedingungen
    };
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/offert', {
        ...options,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printGrueneKarte(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/gruenekarte', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printVorlDeckung(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/vorldeckung', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getServicekarte(polint: number): Observable<PayloadBoolean> {
    return this.http
      .get<PayloadBoolean>(this.baseUrl + '/polizze/' + polint + '/druck/servicekarte', this.httpOptions);
  }

  public getPolizzeDocumentCreateModel(polint: number): Observable<PayloadArchivDocumentPolizzeCreateList> {
    return this.http
      .get<PayloadArchivDocumentPolizzeCreateList>(this.baseUrl + '/polizze/' + polint + '/document/create', this.httpOptions);
  }

  public createPolizzeDocument(polint: number, body: ArchivDocumentPolizzeCreate): Observable<PayloadInteger> {
    return this.http
      .post<PayloadInteger>(this.baseUrl + '/polizze/' + polint + '/document/create', body, this.httpOptions);
  }

  public getAllPositionKlauselnForVertrag(polint: number, vertragId: number): Observable<PayloadKlauselList> {
    return this.http
      .get<PayloadKlauselList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/klausel/position', this.httpOptions);
  }

  public getStatusText(polint: number): Observable<PayloadString> {
    return this.http
      .get<PayloadString>(this.baseUrl + '/polizze/' + polint + '/status', this.httpOptions);
  }

  public getWartungsdiensteLog(polint: number): Observable<PayloadPolizzeAenderungen> {
    return this.http
      .get<PayloadPolizzeAenderungen>(this.baseUrl + '/polizze/' + polint + '/wartungsdienste', this.httpOptions);
  }

  public getTodoForPolice(polint: number): Observable<PayloadTodoResultList> {
    return this.http
      .get<PayloadTodoResultList>(this.baseUrl + '/polizze/' + polint + '/todo', this.httpOptions);
  }

  public getReferate(polint: number): Observable<PayloadPersonReferatList> {
    return this.http
      .get<PayloadPersonReferatList>(this.baseUrl + '/polizze/' + polint + '/referate', this.httpOptions);
  }

  public printKlausel(polint: number, klausel: string): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/klausel/' + klausel + '/druck', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getEinsichtStatus(polint: number): Observable<PayloadObjektEinsichtStatus> {
    return this.http
      .get<PayloadObjektEinsichtStatus>(this.baseUrl + '/polizze/' + polint + '/einsicht', this.httpOptions);
  }

  public einsichtBeantragen(polint: number, body: ObjektEinsicht): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/polizze/' + polint + '/einsicht',
        body,
        this.httpOptions);
  }

  public getPolizzenAussenstand(polint: number): Observable<PayloadPolizzeOpostenSummen> {
    return this.http
      .get<PayloadPolizzeOpostenSummen>(this.baseUrl + '/polizze/' + polint + '/buchungen/aussenstand', this.httpOptions);
  }

  public getPolizzeLebendaten(polint: number): Observable<PayloadLVKPolizzeLeben> {
    return this.http
      .get<PayloadLVKPolizzeLeben>(this.baseUrl + '/polizze/' + polint + '/leben/uebersicht', this.httpOptions);
  }

  public getRueckkaufswerte(polint: number, vertragId: number, datum?: DateString): Observable<PayloadRKWAuskunftResult> {
    const params = {datum};
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadRKWAuskunftResult>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/leben/rueckkaufswerte',
        datum ? options : this.httpOptions);
  }

  public getOffertdruckQuestions(polint: number): Observable<PayloadQuestionsData> {
    return this.http
      .get<PayloadQuestionsData>(this.baseUrl + '/polizze/' + polint + '/druck/offertquestions', this.httpOptions);
  }

  public generateOffertWithQuestions(polint: number, body: QuestionsData): Observable<PayloadFileBucketMetadataList> {
    return this.http
      .post<PayloadFileBucketMetadataList>(this.baseUrl + '/polizze/' + polint + '/druck/offertquestions/generate', body, {
        ...this.httpOptions
      });
  }

  public getHundehaftpflichtQuestions(polint: number): Observable<PayloadQuestionsData> {
    return this.http
      .get<PayloadQuestionsData>(this.baseUrl + '/polizze/' + polint + '/druck/hundehaftpflichtquestions', this.httpOptions);
  }

  public generateHundehaftpflicht(polint: number, body: QuestionsData): Observable<PayloadFileBucketMetadataList> {
    return this.http
      .post<PayloadFileBucketMetadataList>(this.baseUrl + '/polizze/' + polint + '/druck/hundehaftpflicht/generate', body, {
        ...this.httpOptions
      });
  }

  public getFahrzeugbesichtigung(polint: number): Observable<PayloadQuestionsData> {
    return this.http
      .get<PayloadQuestionsData>(this.baseUrl + '/polizze/' + polint + '/druck/fahrzeugbesichtigung', this.httpOptions);
  }

  public generateFahrzeugbesichtigung(polint: number, body: QuestionsData): Observable<PayloadFileBucketMetadataList> {
    return this.http
      .post<PayloadFileBucketMetadataList>(this.baseUrl + '/polizze/' + polint + '/druck/fahrzeugbesichtigung', body, {
        ...this.httpOptions
      });
  }

  public printBedingungen(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/bedingungen', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public downloadHundehaftpflicht(polint: number, file: FileBucketMetadata): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/hundehaftpflicht/download', file, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public downloadFahrzeugbesichtigung(polint: number, file: FileBucketMetadata): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/fahrzeugbesichtigung/download', file, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public downloadOffertWithQuestions(polint: number, file: FileBucketMetadata): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/offertquestions/download', file, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getBerechnungsVorschlagFiles(polint: number): Observable<PayloadFileBucketMetadataList> {
    return this.http
      .get<PayloadFileBucketMetadataList>(this.baseUrl + '/polizze/' + polint + '/druck/berechnungsvorschlag', {
        ...this.httpOptions
      });
  }

  public getBerechnungsVorschlagFilesWord(polint: number): Observable<PayloadFileBucketMetadataList> {
    return this.http
      .get<PayloadFileBucketMetadataList>(this.baseUrl + '/polizze/' + polint + '/druck/berechnungsvorschlagword', {
        ...this.httpOptions
      });
  }

  public downloadPolizzeBerechnungsvorschlag(polint: number, file: FileBucketMetadata): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/berechungsvorschlag/download', file, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getGenehmigungen(polint: number): Observable<PayloadPolizzeGenehmigungList> {
    return this.http
      .get<PayloadPolizzeGenehmigungList>(this.baseUrl + '/polizze/' + polint + '/genehmigungen', this.httpOptions);
  }

  public getPolizzeEsign(polint: number): Observable<PayloadEsignResultList> {
    return this.http
      .get<PayloadEsignResultList>(this.baseUrl + '/polizze/' + polint + '/esign', this.httpOptions);
  }

  public cancelPolizzeEsign(polint: number, esignId: string): Observable<PayloadBoolean> {
    return this.http
      .post<PayloadBoolean>(
        this.baseUrl + '/polizze/' + polint + '/esign/' + esignId + '/cancel',
        null,
        this.httpOptions);
  }

  public getSchadenFormQuestions(polint: number): Observable<PayloadQuestionsData> {
    return this.http
      .get<PayloadQuestionsData>(this.baseUrl + '/polizze/' + polint + '/druck/schadenform', this.httpOptions);
  }

  public generateSchadenFormQuestions(polint: number, body: QuestionsData): Observable<PayloadFileBucketMetadataList> {
    return this.http
      .post<PayloadFileBucketMetadataList>(this.baseUrl + '/polizze/' + polint + '/druck/schadenform/generate', body, {
        ...this.httpOptions
      });
  }

  public downloadSchadenFormQuestions(polint: number, file: FileBucketMetadata): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/schadenform/download', file, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getLebenFormQuestions(polint: number): Observable<PayloadQuestionsData> {
    return this.http
      .get<PayloadQuestionsData>(this.baseUrl + '/polizze/' + polint + '/druck/lebenform', this.httpOptions);
  }

  public generateLebenFormQuestions(polint: number, body: QuestionsData): Observable<PayloadFileBucketMetadataList> {
    return this.http
      .post<PayloadFileBucketMetadataList>(this.baseUrl + '/polizze/' + polint + '/druck/lebenform/generate', body, {
        ...this.httpOptions
      });
  }

  public downloadLebenFormQuestions(polint: number, file: FileBucketMetadata): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/lebenform/download', file, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getPolizzeRabattkonto(polint: number): Observable<PayloadPolizzeRabattkontoResult> {
    return this.http
      .get<PayloadPolizzeRabattkontoResult>(this.baseUrl + '/polizze/' + polint + '/rabattkonto', this.httpOptions);
  }

  public getPolizzeRabattkontoBuchungen(polint: number): Observable<PayloadRabattkontobuchungList> {
    return this.http
      .get<PayloadRabattkontobuchungList>(this.baseUrl + '/polizze/' + polint + '/rabattkonto/buchung', this.httpOptions);
  }

  public getPolizzeEsignLog(polint: number, esignId: number): Observable<PayloadEsignLogList> {
    return this.http
      .get<PayloadEsignLogList>(this.baseUrl + '/polizze/' + polint + '/esign/' + esignId + '/log', this.httpOptions);
  }

  public getPolizzeFondplus(polint: number): Observable<PayloadPolizzeFond> {
    return this.http
      .get<PayloadPolizzeFond>(this.baseUrl + '/polizze/' + polint + '/leben/fond', this.httpOptions);
  }

  public getPositionVeranlagung(polint: number, vernr: number, posnr: number): Observable<PayloadPositionVeranlagungList> {
    return this.http
      .get<PayloadPositionVeranlagungList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr + '/leben/veranlagung', this.httpOptions);
  }

  public getPositionVeranlagungFondanteile(polint: number, vernr: number, posnr: number, vanId: number): Observable<PayloadPositionLebenFondAnteileList> {
    return this.http
      .get<PayloadPositionLebenFondAnteileList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr + '/leben/veranlagung/' + vanId + '/fondanteile', this.httpOptions);
  }

  public getPositionGewinnkonto(polint: number, vernr: number, posnr: number): Observable<PayloadPositionGewinnkontoList> {
    return this.http
      .get<PayloadPositionGewinnkontoList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr + '/leben/gewinnkonto', this.httpOptions);
  }

  public getPositionLebenkonto(polint: number, vernr: number, posnr: number): Observable<PayloadPositionLebenkontoList> {
    return this.http
      .get<PayloadPositionLebenkontoList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr + '/leben/lebenkonto', this.httpOptions);
  }

  public getPositionZuzahlung(polint: number, vernr: number, posnr: number): Observable<PayloadPositionZuzahlungList> {
    return this.http
      .get<PayloadPositionZuzahlungList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr + '/leben/zuzahlung', this.httpOptions);
  }

  public getPositionTeilentnahme(polint: number, vernr: number, posnr: number): Observable<PayloadPositionTeilentnahmenList> {
    return this.http
      .get<PayloadPositionTeilentnahmenList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr + '/leben/teilentnahme', this.httpOptions);
  }

  public getPositionRentenkonto(polint: number, vernr: number, posnr: number): Observable<PayloadPositionRentenkontoList> {
    return this.http
      .get<PayloadPositionRentenkontoList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr + '/leben/rentenkonto', this.httpOptions);
  }

  public getPositionPrognose(polint: number, vernr: number, posnr: number): Observable<PayloadPositionPrognoseList> {
    return this.http
      .get<PayloadPositionPrognoseList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr + '/leben/prognose', this.httpOptions);
  }

  public getPositionGewinnprognose(polint: number, vernr: number, posnr: number): Observable<PayloadPositionGewinnprognoseList> {
    return this.http
      .get<PayloadPositionGewinnprognoseList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vernr + '/position/' + posnr + '/leben/gewinnprognose', this.httpOptions);
  }

  public getPolizzeAchtung(polint: number): Observable<PayloadTerminList> {
    return this.http
      .get<PayloadTerminList>(this.baseUrl + '/polizze/' + polint + '/termine/achtung', this.httpOptions);
  }

  public getPolizzeDFZ(polint: number): Observable<PayloadPolizzeDFZList> {
    return this.http
      .get<PayloadPolizzeDFZList>(this.baseUrl + '/polizze/' + polint + '/dfz', this.httpOptions);
  }

  public getVertragSelbstbehalt(polint: number, vertragId: number): Observable<PayloadVertragSelbstbehaltList> {
    return this.http
      .get<PayloadVertragSelbstbehaltList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/selbstbehalt', this.httpOptions);
  }

  public getPositionSelbstbehalt(polint: number, vertragId: number, positionId: number): Observable<PayloadPositionSelbstbehaltList> {
    return this.http
      .get<PayloadPositionSelbstbehaltList>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/position/' + positionId + '/selbstbehalt', this.httpOptions);
  }

  public getPolizzeFamilienpassXML(polint: number): Observable<PayloadPolizzeFampassXMLDatenList> {
    return this.http
      .get<PayloadPolizzeFampassXMLDatenList>(this.baseUrl + '/polizze/' + polint + '/familienpass', this.httpOptions);
  }

  public getPositionBilanz(polint: number, vertragId: number, positionId: number): Observable<PayloadPositionLebenBilanz> {
    return this.http
      .get<PayloadPositionLebenBilanz>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/position/' + positionId + '/leben/bilanz', this.httpOptions);
  }

  public getPositionFonds(polint: number, vertragId: number, positionId: number, stichtag?: DateString): Observable<PayloadPositionLebenFond> {
    const params = {stichtag};
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPositionLebenFond>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/position/' + positionId + '/leben/fonds', options);
  }

  public getPolizzeCocheck(polint: number): Observable<PayloadPolizzeCocheckList> {
    return this.http
      .get<PayloadPolizzeCocheckList>(this.baseUrl + '/polizze/' + polint + '/cocheck', this.httpOptions);
  }

  public getPolizzeZis(polint: number): Observable<PayloadPolizzeZisList> {
    return this.http
      .get<PayloadPolizzeZisList>(this.baseUrl + '/polizze/' + polint + '/zis', this.httpOptions);
  }

  public getPolizzeApol(polint: number): Observable<PayloadPolizzeApolList> {
    return this.http
      .get<PayloadPolizzeApolList>(this.baseUrl + '/polizze/' + polint + '/apol', this.httpOptions);

  }

  public getPolizzeIdent(polint: number): Observable<PayloadPolizzeIdentitaetsdatenList> {
    return this.http
      .get<PayloadPolizzeIdentitaetsdatenList>(this.baseUrl + '/polizze/' + polint + '/ident', this.httpOptions);
  }

  public getPolizzeProduktionsblatt(polint: number): Observable<PayloadPolizzeProduktionsblatt> {
    return this.http
      .get<PayloadPolizzeProduktionsblatt>(this.baseUrl + '/polizze/' + polint + '/produktionsblatt', this.httpOptions);
  }

  public getPolizzeMahnhistorie(polint: number): Observable<PayloadMahnhistorieResultList> {
    return this.http
      .get<PayloadMahnhistorieResultList>(this.baseUrl + '/polizze/' + polint + '/mahnhistorie', this.httpOptions);
  }

  public getVertragBeteiligung(polint: number, vertragId: number): Observable<PayloadBeteiligung> {
    return this.http
      .get<PayloadBeteiligung>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/beteiligung', this.httpOptions);
  }

  public getPolizzeFreischaden(polint: number): Observable<PayloadPolizzeFreischadenList> {
    return this.http
      .get<PayloadPolizzeFreischadenList>(this.baseUrl + '/polizze/' + polint + '/freischaden', this.httpOptions);
  }

  public printGruenekarteFlotte(polint: number, body: GrueneKarteDruck): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/gruenekarteflotte', body, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public familienpassDatenabgleich(polint: number): Observable<PayloadBoolean> {
    return this.http
      .patch<PayloadBoolean>(this.baseUrl + '/polizze/' + polint + '/familienpass/datenabgleich', null, this.httpOptions);
  }

  public getRelevantestePolizze(polNr: string): Observable<PayloadPolizzeResult> {
    const params = {polNr};
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPolizzeResult>(this.baseUrl + '/polizze/analyse/relevanteste', options);
  }

  public printVertragAVB(polint: number, vertragId: number, avbId: string): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/avb/' + avbId + '/druck', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printBonusMalusUebertrag(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/bonusmalusuebertrag', {}, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPolizzeFromArchive(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/polizzefromarchive', {}, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getVertragZinsspektrum(polint: number, vertragId: number): Observable<PayloadZinsspektrum> {
    return this.http
      .get<PayloadZinsspektrum>(this.baseUrl + '/polizze/' + polint + '/vertrag/' + vertragId + '/leben/zinsspektrum', this.httpOptions);
  }

  public printOriginalPolizzeFromArchive(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/polizze/' + polint + '/druck/originalpolizzefromarchive', {}, {
        ...this.httpOptions,
        observe:      'response',
        responseType: 'blob' as 'json'
      });
  }

  public postPolizzeTodo(polint: number, body: TodoCreation): Observable<PayloadTodoResult> {
    return this.http
      .post<PayloadTodoResult>(
        this.baseUrl + '/polizze/' + polint + '/todo',
        body,
        this.httpOptions);
  }
}
